import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("textBlock3", component(opts));
  editor.BlockManager.add("textBlock3", block(opts));
};